// extracted by mini-css-extract-plugin
export var actionIcon = "_uo-0";